import { useAuth, useUser } from '@clerk/react'
import { type ReactNode, useEffect, useRef } from 'react'
import { initPostHog, posthog } from '@/lib/posthog'

interface PostHogProviderProps {
  children: ReactNode
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const { isSignedIn } = useAuth()
  const { user, isLoaded: userLoaded } = useUser()
  const identifiedRef = useRef(false)
  const initializedRef = useRef(false)

  useEffect(() => {
    if (initializedRef.current) return
    if (typeof window === 'undefined') return

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bootstrapFlags = (window as any).__POSTHOG_BOOTSTRAP__ as
      | Record<string, boolean | string>
      | undefined

    initializedRef.current = initPostHog(bootstrapFlags)
  }, [])

  useEffect(() => {
    if (!initializedRef.current) return
    if (!userLoaded) return

    if (isSignedIn && user && !identifiedRef.current) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.publicMetadata?.role ?? null,
      })
      identifiedRef.current = true
    } else if (!isSignedIn && identifiedRef.current) {
      posthog.reset()
      identifiedRef.current = false
    }
  }, [isSignedIn, user, userLoaded])

  return <>{children}</>
}
